export enum SAVE_STATUS {
    LOADING,
    NO_CHANGES,
    CAN_BE_SAVED,
    CURRENTLY_SAVING,
    CHANGES_SAVED
}
